import { SocialSite } from '@/type';
import api from '../API';

export default {
  async find(id: number): Promise<SocialSite> {
    const socialSites = await this.findAll();
    const socialSite = socialSites.find(ss => ss.id === id);
    if (socialSite) return socialSite;
    throw new Error(`Social with ID ${id} not found`);
  },
  findAll(): Promise<SocialSite[]> {
    return api
      .get('social-sites')
      .then(response => response.data);
  },
};
